import React, {useEffect, useState, useCallback} from 'react';
import {makeStyles} from '@mui/styles';
import {useSelector} from 'react-redux';
import { Button, Card, CardHeader, Grid, Tooltip } from '@mui/material';
import {companyService} from "../../store/services";
import {ConnectedApp} from "./components";
import PageHeader from "../../components/PageHeader/PageHeader";
import LoadingSpinner from "../../components/Spinner/loading.spinner";
import CardBody from '../../components/Card/CardBody';
import { ExpandLess, ExpandMore, Sort, Refresh } from '@mui/icons-material';
import { toastHelper } from '../../helpers/toast.helper';
import { alertActions } from '../../store/actions';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  content: {
    marginTop: theme.spacing(0)
  },
  action: {
    marginRight: theme.spacing(2)
  },
  button: {
    marginLeft: theme.spacing(1)
  }
}));
const ConnectedApps = () => {
  const classes = useStyles();
  const user = useSelector(state => state.authentication.user);
  const [connectedApps, setConnectedApps] = useState([]);
  const [requestPending, setRequestPending] = useState(false);
  const [sortDirection, setSortDirection] = useState(0 ); // 0- No Direction, 1 -Ascending, 2 - Descending

  const sort_by = (field, reverse, primer) => {

    const key = primer ?
      function(x) {
        return primer(x[field])
      } :
      function(x) {
        return x[field]
      };

    reverse = !reverse ? 1 : -1;

    return function(a, b) {
      return (a = key(a), b = key(b), reverse * ((a > b) - (b > a)));
    }
  }

  const handleRefresh = useCallback(() => {
    setRequestPending(true);
    companyService.getActiveConnectedApps(user.companyId)
      .then((results) => {
        setConnectedApps(results.data.connectedApps);
        setSortDirection(0);
        setRequestPending(false);
      });
  }, [user.companyId]);

  const handleUpdateSort = () => {
    let sort =  ((sortDirection + 1) > 2) ? 1 : sortDirection + 1;
    setSortDirection(sort);
  }

  let connectedAppsList = connectedApps;
  switch (sortDirection) {
    case 1:
      connectedAppsList.sort(sort_by('name', false, (a) => a.toUpperCase()));
      break;
    case 2:
      connectedAppsList.sort(sort_by('name', true, (a) => a.toUpperCase()));
      break;
    default:
      break;
  };

  useEffect(() => {
    handleRefresh()
  }, [handleRefresh]); //

  return (
    <div className={classes.root}>
      <PageHeader
        subTitle={'Orchestrated Apps Portal'}
        title={'Orchestrated Apps'}
      />
      <Card  className={classes.content}>
        <CardHeader
          className={classes.titleHeader}
          classes={{
            action: classes.action
          }}
          action={[
            <Tooltip
              title="Sort Orchestrated Apps"
              aria-label="Sort"
            >
              <Button
                className={classes.button}
                variant="contained"
                color={"primary"}
                key="sort"
                onClick={handleUpdateSort}
                startIcon={(sortDirection === 0) ? ("") : (sortDirection === 1) ? (<ExpandLess />) : (<ExpandMore />)}
              >
                Sort
              </Button>
            </Tooltip>,
            <Tooltip
              title="Refresh Orchestrated Apps"
              aria-label="Refresh"
            >
              <Button
                className={classes.button}
                variant="contained"
                color={"primary"}
                key="refresh"
                onClick={handleRefresh}
                startIcon={<Refresh />}
              >
                Refresh
              </Button>
            </Tooltip>
          ]}
        />
        <CardBody>
          {(connectedAppsList.length > 0) && !requestPending ? (
              <Grid container justifyContent={"flex-start"}>
                {connectedAppsList.map((app, index) => (
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={index}>
                    <ConnectedApp
                      key={index}
                      connectedApp={app}
                    />
                  </Grid>
                ))}
              </Grid>)

            :
            (<LoadingSpinner/>)

          }
        </CardBody>
      </Card>
    </div>
  );
};

export default ConnectedApps;
